import styled from 'styled-components';
import WorkOperationsTable from '$app/components/vendor/WorkOperationsTable';

export default styled(WorkOperationsTable)`
  thead tr:first-child th:nth-child(3) {
    border-top: 1px solid #ebebeb;
    border-right: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
  }
  thead tr:first-child th:nth-child(3),
  thead tr:nth-child(2) th:nth-child(6),
  thead tr:nth-child(2) th:nth-child(7),
  tr td:nth-child(6),
  tr td:nth-child(7) {
    border-left: 1px solid #ebebeb;
  }
  tr td:nth-child(7),
  thead tr:nth-child(2) th:nth-child(7) {
    border-right: 1px solid #ebebeb;
  }
  tbody tr.group td {
    padding-top: 23px !important;
    height: 70px !important;
    font-size: 14px;
  }
  tbody tr {
    .table-row-expand-icon,
    .indent-level-1 {
      margin: 0;
    }
    .cell-workOperation {
      .mot_result {
        margin-left: 10px;
        padding: 6px 10px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: bold;
        .mot_date {
          margin-left: 5px;
          font-size: 10px;
          color: #9e9eac;
          }
        }
      .pending {
        border: solid 1px #6d7484;
        background-color: #f0f1f2;
        color: #6d7484;
        }
      .passed {
        border: solid 1px #3ae6b1;
        background-color: #ebfcf7;
        color: #3ae6b1;
        }
      .failed {
        border: solid 1px #ff5857;
        background-color: #ffeeee;
        color: #ff5857;
        }

    }
  }
  .additional-item, .group {
    background: #fffbe9 !important;
  }
  .discount-row {
    background: #eaffea !important;
  }
  .additional-item--declined, .status-deleted {
    text-decoration: line-through !important;
    opacity: 0.8;
    color: #888;
  }
`;
